import { createGlobalStyle } from 'styled-components';
import reset from 'styled-reset';
import theme from '@styles/theme';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-toastify/dist/ReactToastify.css';
import 'react-quill-new/dist/quill.snow.css';
// import 'react-image-crop/dist/ReactCrop.css';

export default createGlobalStyle`
  ${reset}

  @font-face {
    font-family: AppleSDGothicNeoBold;
    src: url('/fonts/appleSDGothic/AppleSDGothicNeo-Bold.woff2') format('woff2');
    font-weight: 700;
    font-display: swap;
  }

  @font-face {
    font-family: AppleSDGothicNeoSemiBold;
    src: url('/fonts/appleSDGothic/AppleSDGothicNeo-SemiBold.woff2') format('woff2');
    font-weight: 600;
    font-display: swap;
  }

  @font-face {
    font-family: AppleSDGothicNeoMedium;
    src: url('/fonts/appleSDGothic/AppleSDGothicNeo-Medium.woff2') format('woff2');
    font-weight: 500;
    font-display: swap;
  }

  @font-face {
    font-family: AppleSDGothicNeoRegular;
    src: url('/fonts/appleSDGothic/AppleSDGothicNeo-Regular.woff2') format('woff2');
    font-weight: 400;
    font-display: swap;
  }


  @font-face {
    font-family: PretendardBold;
    src: url('/fonts/pretendard/Pretendard-Bold.woff') format('woff');
    font-weight: 700;
    font-display: swap;
  }

  @font-face {
    font-family: PretendardSemiBold;
    src: url('/fonts/pretendard/Pretendard-SemiBold.woff') format('woff');
    font-weight: 600;
    font-display: swap;
  }

  @font-face {
    font-family: PretendardMedium;
    src: url('/fonts/pretendard/Pretendard-Medium.woff') format('woff');
    font-weight: 500;
    font-display: swap;
  }

  @font-face {
    font-family: PretendardRegular;
    src: url('/fonts/pretendard/Pretendard-Regular.woff') format('woff');
    font-weight: 400;
    font-display: swap;
  }

  @font-face {
    font-family: Tenda;
    src: url('/fonts/tenada/Tenada.woff2') format('woff2');
    font-weight: 600;
    font-display: swap;
  }

  * {
    box-sizing: border-box;
    -ms-overflow-style: auto; // 인터넷 익스플로러
    scrollbar-width: block; // 파이어폭스
    &::-webkit-scrollbar {
      width: 10px;
      height: 10px;
      display: block;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      background: ${({ theme }) => theme.colors.lightGrayFontColor} !important; // 스크롤바의 색상
    }
  }

  body {
    width: calc(100vw - 10px);
    font-size: 15px;
    font-family: PretendardRegular, AppleSDGothicNeoRegular, sans-serif;
    background-color: ${({ theme }) => theme.colors.whiteColor};
  }

  a {
    color: ${({ theme }) => theme.colors.blackColor};
    text-decoration: none;
  }

  textarea {
    resize: none;
  }

  input,
  textarea {
    font-size: 14px;
    font-family: PretendardRegular, sans-serif;
    border: none;
    outline: none;
    background-color: inherit;

    &::placeholder {
      font-size: 14px;
      font-family: PretendardRegular, sans-serif;
      color: ${({ theme }) => theme.colors.deepGrayFontColor};
    }

    &:disabled {
      color: ${({ theme }) => theme.colors.blackColor};
      background: inherit;
      background-color: ${({ theme }) => theme.colors.ultraLightGrayBorder};
    }
  }

  input[type="number"]::-webkit-outer-spin-button,
  input[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  textarea:focus,
  input:focus {
    outline: none;
  }

  button {
    font-size: 15px;
    font-family: PretendardRegular, sans-serif;
    padding: 0;
    outline: none;
    border: none;
    background-color: ${({ theme }) => theme.colors.whiteColor};
    cursor: pointer;
  }

  select {
    font-size: 14px;
    border: none;
    outline: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    cursor: pointer;

    &:disabled {
      background-color: ${theme.colors.ultraLightGrayBorder};
    }
  }

  .Toastify__toast-container {
    width: 320px;
  }

  .Toastify__toast-container div {
    font-size: 15px;
    line-height: 1.2;
    white-space: pre-wrap;
    word-break: keep-all !important;
  }

  h1 {
    font-size: 32px !important;
    font-weight: bold !important;
  }
  h2 {
    font-size: 24px !important;
    font-weight: bold !important;
  }
  h3 {
    font-size: 19px !important;
    font-weight: bold !important;
  }
  h4 {
    font-size: 16px !important;
    font-weight: bold !important;
  }
  h5 {
    font-size: 12px !important;
    font-weight: bold !important;
  }
  h6 {
    font-size: 10px !important;
    font-weight: bold !important;
  }

  em {
    font-style: italic !important;
  }

  b, strong {
    font-weight: bold !important;
  }

  // React Quill Style
  // font family
  // AppleSDGothicNeo
  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value='AppleSDGothicNeo']::before,
  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value='AppleSDGothicNeo']::before {
    content: 'AppleSDGothicNeo';
    font-family: AppleSDGothicNeoMedium, sans-serif !important;;
  }

  .ql-font-AppleSDGothicNeo {
    font-family: AppleSDGothicNeoMedium, sans-serif !important;;
  }

  // Nanum Gothic
  span.ql-font-NanumGothic,
  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value='NanumGothic']::before,
  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value='NanumGothic']::before {
    content: 'NanumGothic';
    font-family: 'Nanum Gothic', sans-serif !important;
  }

  .ql-font-AppleSDGothicNeo {
    font-family: AppleSDGothicNeoMedium, sans-serif !important;;
  }

  // pretendard
  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value='pretendard']::before,
  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value='pretendard']::before {
    content: 'pretendard';
    font-family: PretendardMedium, sans-serif !important;;
  }

  .ql-font-pretendard {
    font-family: PretendardMedium, sans-serif !important;;
  }

  // sans-serif
  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value='sans-serif']::before,
  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value='sans-serif']::before {
    content: 'sans-serif';
    font-family: sans-serif !important;;
  }

  .ql-font-sans-serif {
    font-family: sans-serif !important;;
  }

  // monospace
  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value='monospace']::before,
  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value='monospace']::before {
    content: 'monospace';
    font-family: monospace !important;;
  }

  .ql-font-monospace {
    font-family: monospace !important;;
  }

  // font size
  .ql-size-12px,
  .ql-size span[data-value='12px']::before {
    font-size: 12px !important;
  }

  .ql-size-14px,
  .ql-size span[data-value='14px']::before {
    font-size: 14px !important;
  }

  .ql-size-15px,
  .ql-size span[data-value='15px']::before {
    font-size: 15px !important;
  }

  .ql-size-16px,
  .ql-size span[data-value='16px']::before {
    font-size: 16px !important;
  }

  .ql-size-18px,
  .ql-size span[data-value='18px']::before {
    font-size: 18px !important;
  }

  .ql-size-20px,
  .ql-size span[data-value='20px']::before {
    font-size: 20px !important;
  }

  .ql-size-22px,
  .ql-size span[data-value='22px']::before {
    font-size: 22px !important;
  }

  .ql-size-24px,
  .ql-size span[data-value='24px']::before {
    font-size: 24px !important;
  }

  .ql-size-26px,
  .ql-size span[data-value='26px']::before {
    font-size: 26px !important;
  }

  .ql-size-28px,
  .ql-size span[data-value='28px']::before {
    font-size: 28px !important;
  }

  .ql-size-30px,
  .ql-size span[data-value='30px']::before {
    font-size: 30px !important;
  }

  .ql-size-32px,
  .ql-size span[data-value='32px']::before {
    font-size: 32px !important;
  }

  // Bold
  .ql-editor strong {
    font-weight: bold !important;
  }

  .ql-editor b {
    font-weight: bold !important;
  }

  .ql-editor em {
    font-style: italic !important;
  }

  // Underline
  .ql-editor u {
    text-decoration: underline !important;
  }

  // Strike
  .ql-editor s,
  .ql-editor del,
  .ql-editor strike {
    text-decoration: line-through !important;
  }

  // Superscript & Subscript
  .ql-editor sub {
    vertical-align: sub !important;
    font-size: smaller !important;
  }

  .ql-editor sup {
    vertical-align: super !important;
    font-size: smaller !important;
  }

  // Blockquote
  .ql-editor blockquote {
    border-left: 4px solid #ccc !important;
    padding-left: 16px !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
    color: #666 !important;
  }

  // Code Block
  .ql-editor pre.ql-syntax,
  .ql-editor pre {
    background-color: #f4f4f4 !important;
    border: 1px solid #ddd !important;
    border-radius: 4px !important;
    padding: 12px !important;
    overflow-x: auto !important;
    font-family: 'Courier New', monospace !important;
    font-size: 14px !important;
    line-height: 1.5 !important;
    color: #333 !important;
  }

  // Lists
  .ql-editor ol,
  .ql-editor ul {
    padding-left: 1.5em !important;
    margin: 0 !important;
  }

  .ql-editor ol li,
  .ql-editor ul li {
    list-style-type: inherit !important;
  }

  .ql-editor ul li {
    list-style-type: disc !important;
  }

  .ql-editor ol li {
    list-style-type: decimal !important;
  }

  // Indent
  .ql-editor .ql-indent-1 {
    padding-left: 3em !important;
  }

  .ql-editor .ql-indent-2 {
    padding-left: 6em !important;
  }

  .ql-editor .ql-indent-3 {
    padding-left: 9em !important;
  }

  .ql-editor .ql-indent-4 {
    padding-left: 12em !important;
  }

  .ql-editor .ql-indent-5 {
    padding-left: 15em !important;
  }

  .ql-editor .ql-indent-6 {
    padding-left: 18em !important;
  }

  .ql-editor .ql-indent-7 {
    padding-left: 21em !important;
  }

  .ql-editor .ql-indent-8 {
    padding-left: 24em !important;
  }

  .ql-editor p:empty::before {
    content: '\\200B'; // 공백 문자 추가로 빈 p 태그도 높이 확보
  }

  .ql-picker {
    &.ql-size {
      .ql-picker-label,
      .ql-picker-item {
        &::before {
          content: attr(data-value) !important;
        }
      }
    }
  }
  
  // Link
  .ql-editor a {
    color: #007bff !important;
    text-decoration: underline !important;
    cursor: pointer !important;
  }

  .ql-editor a:hover {
    color: #0056b3 !important;
  }

  // Image
  .ql-editor img {
    max-width: 100% !important;
    height: auto !important;
  }

  // Video
  .ql-editor iframe.ql-video {
    width: 100% !important;
    height: 400px !important;
  }

  // Alignment
  .ql-align-left {
    text-align: left !important;
  }

  .ql-align-center {
    text-align: center !important;
  }

  .ql-align-right {
    text-align: right !important;
  }

  .ql-align-justify {
    text-align: justify !important;
  }

  // Direction (RTL)
  .ql-direction-rtl {
    direction: rtl !important;
    text-align: right !important;
  }
`;
